module.exports = __webpack_public_path__ + "img/tier1-more-info.4e3dd55.svg";